export default function GenerateButton({ onClick, isLoading, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`group relative w-full overflow-hidden rounded-2xl py-4 font-black uppercase tracking-[0.2em] text-sm transition-all duration-300 disabled:opacity-50 disabled:grayscale disabled:cursor-not-allowed ${isLoading
        ? 'bg-slate-100 dark:bg-white/5 cursor-wait'
        : 'bg-gradient-to-r from-violet-600 via-fuchsia-600 to-violet-600 bg-[length:200%_100%] hover:bg-[100%_0] text-white shadow-[0_20px_40px_-15px_rgba(168,85,247,0.5)] hover:shadow-[0_25px_50px_-12px_rgba(168,85,247,0.6)] hover:scale-[1.02] active:scale-95'
        }`}
    >
      <div className="relative flex items-center justify-center gap-3">
        {isLoading ? (
          <>
            <div className="w-5 h-5 rounded-full border-2 border-violet-500 border-t-transparent animate-spin" />
            <span className="text-slate-500 dark:text-slate-400">Generating Icons...</span>
          </>
        ) : (
          <>
            <svg className="w-5 h-5 transition-transform group-hover:rotate-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            <span>Generate Icons</span>
            <div className="absolute inset-0 bg-white/10 translate-y-full group-hover:translate-y-0 transition-transform duration-500" />
          </>
        )}
      </div>
    </button>
  );
}
